<script>
import { mapActions } from 'vuex'
import { add, edit } from '@/api/tabeladesconto'
import fields from './fields'
import { setFocus } from '@/services/crud'
import localModalidades from './modalidades'

export default {
  components: {
    localModalidades
  },
  props: {
    mode: { type: String, default: 'tab' }
  },
  data: () => ({
    fields,
    form: {}
  }),
  methods: {
    ...mapActions({
      toaster: 'modal/toaster'
    }),
    focuInicial () {
      setFocus('input[type="text"]', this.$refs.form.$el)
    },
    refresh (data) {
      this.form = JSON.parse(JSON.stringify(data))
      if (!this.form.id) this.$refs.form.instance.resetValues()
      this.focuInicial()
    },
    trataDados () {
      let dados = JSON.parse(JSON.stringify(this.form))
      if (dados.modalidades) {
        dados.modalidades = dados.modalidades.map(e => {
          let id = e.id || null
          return { id, tipo_modalidade: e.tipo_modalidade, perc_desconto: e.perc_desconto }
        })
      } else dados.modalidades = []
      return dados
    },
    async salvar () {
      // Salvar Editar
      try {
        let valida = this.$refs.form.instance.validate()
        if (!valida.isValid) throw new Error('Campos Inválidos')
        let dados = this.trataDados()
        let data = {}
        if (dados.id) {
          data = await edit(dados.id, dados)
          this.toaster({ message: 'Editado com sucesso!', color: 'success' })
        } else {
          data = await add(dados)
          this.toaster({ message: 'Adicionado com sucesso!', color: 'success' })
        }
        this.$emit('save', data)
      } catch (e) {
        this.toaster({ message: e.message, color: 'error' })
      }
    }
  }
}
</script>

<template>
  <ui-layout-modal :mode="mode" title="Adicionar" @onClose="() => $emit('cancel')">
    <dx-form ref="form" label-location="top" :form-data="form" :items="fields" :onEditorEnterKey="salvar">
      <local-modalidades slot="gridModalidade" slot-scope="data" :model="form.modalidades" @change="v => form.modalidades = v" />
    </dx-form>
    <ui-acao-form @save="salvar" @cancel="$emit('cancel')" />
  </ui-layout-modal>
</template>

<style scoped>
  .card-form {
    text-align: left;
  }
</style>
